import { EntityAndColumnType } from '@entities/types';
import { WizardResultsLineageDataEntity, WizardResultsLineageDataEntityList } from '../models';

let _uid = -1;

export const GhostRootLineageDataEntityName = '_ghost_root_';
export const GhostRootLineageDataEntityType = 'GhostNode';

export const GhostRootLineageDataEntity = (nodeDepth = 0): WizardResultsLineageDataEntity => {
  return {
    id: _uid--,
    name: `${GhostRootLineageDataEntityName}`,
    type: `${GhostRootLineageDataEntityType}` as unknown as EntityAndColumnType,
    platform: 'Unknown',
    subType: '',
    children: [] as WizardResultsLineageDataEntityList,
    isColumn: false,
    nodeDepth,
    columnsChildren: null,
    objectId: null,
    objectName: `${GhostRootLineageDataEntityName}`,
    columnId: null,
    columnLabel: null,
    toBeActivated: null,
    toBeAdded: null,
    actionToBeDone: null,
    actionToBeDoneCount: -1,
    toBeAddedCount: -1,
    toBeActivatedCount: -1,
    noActionCount: -1,
  };
};
